<template>
  <layout>
    <page-header :header="$t('account.settings')" />
    <div class="content">
      <form ref="form" @submit.prevent="submit">
        <b-row>
          <b-col lg="6">
            <b-card :title="$t('account.general')">
              <fields :form="this" ungrouped />
            </b-card>
          </b-col>
          <b-col lg="6">
            <b-card :title="$t('account.billing')">
              <fields :form="this" group="billing" />
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col v-if="$allows('administer')" lg="6">
            <b-card :title="$t('account.admin_notifications')">
              <fields
                :form="this"
                group="admin_notifications"
                layout="vertical"
              />
            </b-card>
          </b-col>
          <b-col v-else lg="6">
            <b-card :title="$t('account.notifications')">
              <fields :form="this" group="notifications" layout="vertical" />
            </b-card>
          </b-col>
        </b-row>
        <div>
          <b-button type="submit" variant="primary">
            {{ $t('general.save') }}
          </b-button>
        </div>
      </form>
    </div>
  </layout>
</template>

<script>
import { FormMixin } from 'stylemix-base'
import AccountApi from './AccountApi'

export default {
  name: 'AccountForm',

  mixins: [FormMixin],

  mounted() {
    this.loadForm()
  },

  methods: {
    loadForm() {
      let promise = new AccountApi().profileForm().then(result => {
        this.model = result.data
        this.setFields(result.fields)
      })
      this.$uiBlocker(promise, this.$refs.form)
    },
    submit() {
      let formData = this.formData(this.model)
      let promise = new AccountApi().saveProfile(formData).then(result => {
        this.$toast.success(result.message)
      })
      this.$uiBlocker(promise, this.$refs.content)
    },
  },
}
</script>

